var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 75,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M81.2596 75.0002C81.2596 78.4575 78.457 81.2601 74.9996 81.2601C71.5421 81.2601 68.7395 78.4575 68.7395 75.0002C68.7395 71.5428 71.5421 68.74 74.9996 68.74C78.457 68.74 81.2596 71.5428 81.2596 75.0002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M81.2596 31.2602C81.2596 34.7175 78.457 37.5203 74.9996 37.5203C71.5421 37.5203 68.7395 34.7175 68.7395 31.2602C68.7395 27.8029 71.5421 25.0001 74.9996 25.0001C78.457 25.0001 81.2596 27.8029 81.2596 31.2602Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2596 53.1301C81.2596 56.5874 78.457 59.3902 74.9996 59.3902C71.5421 59.3902 68.7395 56.5874 68.7395 53.1301C68.7395 49.6728 71.5421 46.8699 74.9996 46.8699C78.457 46.8699 81.2596 49.6728 81.2596 53.1301Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.551 33.9901C60.2796 36.9844 59.2539 40.8129 56.2597 42.5418C53.2654 44.2702 49.4367 43.2445 47.708 40.2502C45.9794 37.2562 47.0055 33.4274 49.9993 31.6988C52.9936 29.9701 56.8223 30.996 58.551 33.9901Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2498 47.7087C43.2441 49.4374 44.2698 53.2661 42.5411 56.2604C40.8125 59.2544 36.9837 60.2803 33.9897 58.5517C30.9954 56.823 29.9695 52.9943 31.6982 50.0002C33.427 47.0059 37.2556 45.98 40.2498 47.7087Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2599 68.74C34.7173 68.74 37.5201 71.5428 37.5201 75.0002C37.5201 78.4575 34.7173 81.2601 31.2599 81.2601C27.8026 81.2601 25 78.4575 25 75.0002C25 71.5428 27.8026 68.74 31.2599 68.74Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9895 91.4488C36.9838 89.7201 40.8123 90.7458 42.5412 93.7401C44.2698 96.7343 43.2439 100.563 40.2497 102.292C37.2556 104.02 33.4269 102.994 31.6982 100C29.9696 97.0062 30.9953 93.1774 33.9895 91.4488Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.709 109.75C49.4376 106.756 53.2664 105.73 56.2606 107.459C59.2547 109.187 60.2806 113.016 58.5519 116.01C56.8233 119.004 52.9946 120.03 50.0003 118.302C47.0062 116.573 45.9803 112.744 47.709 109.75Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7395 118.74C68.7395 115.283 71.5421 112.48 74.9994 112.48C78.457 112.48 81.2596 115.283 81.2596 118.74C81.2596 122.197 78.457 125 74.9994 125C71.5421 125 68.7395 122.197 68.7395 118.74Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4474 116.01C89.7188 113.016 90.7445 109.187 93.7387 107.458C96.733 105.73 100.562 106.756 102.29 109.75C104.019 112.744 102.993 116.573 99.9991 118.301C97.0048 120.03 93.1761 119.004 91.4474 116.01Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M109.749 102.292C106.755 100.563 105.729 96.7343 107.458 93.74C109.186 90.746 113.015 89.7201 116.009 91.4487C119.003 93.1776 120.029 97.0061 118.3 100C116.572 102.994 112.743 104.02 109.749 102.292Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M118.74 81.2601C115.283 81.2601 112.48 78.4575 112.48 75.0002C112.48 71.5426 115.283 68.74 118.74 68.74C122.197 68.74 125 71.5426 125 75.0002C125 78.4575 122.197 81.2601 118.74 81.2601Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M116.009 58.5515C113.015 60.2802 109.186 59.2543 107.457 56.2602C105.729 53.266 106.755 49.4372 109.749 47.7086C112.743 45.9799 116.572 47.0058 118.3 50.0001C120.029 52.9942 119.003 56.8229 116.009 58.5515Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M102.29 40.2502C100.562 43.2445 96.733 44.2702 93.7387 42.5418C90.7446 40.8129 89.7187 36.9844 91.4474 33.9901C93.176 30.996 97.0048 29.9701 99.999 31.6988C102.993 33.4274 104.019 37.2562 102.29 40.2502Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1902 58.6438C62.1843 60.3724 63.2102 64.201 61.4815 67.1952C59.7528 70.1895 55.9241 71.2152 52.9301 69.4865C49.9358 67.7579 48.9099 63.9294 50.6385 60.9351C52.3674 57.9408 56.1959 56.9151 59.1902 58.6438Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9299 80.5137C55.9242 78.785 59.7527 79.8107 61.4816 82.805C63.2102 85.7992 62.1841 89.628 59.19 91.3566C56.196 93.0853 52.3672 92.0594 50.6386 89.0653C48.9099 86.071 49.9356 82.2423 52.9299 80.5137Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7395 96.8701C68.7395 93.4128 71.5421 90.6102 74.9994 90.6102C78.457 90.6102 81.2596 93.4128 81.2596 96.8701C81.2596 100.327 78.457 103.13 74.9994 103.13C71.5421 103.13 68.7395 100.327 68.7395 96.8701Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M90.809 91.3565C87.8149 89.6278 86.789 85.7991 88.5177 82.8048C90.2464 79.8107 94.0751 78.7848 97.0692 80.5135C100.063 82.2421 101.089 86.0709 99.3607 89.0651C97.6318 92.0594 93.8033 93.0851 90.809 91.3565Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0693 69.4865C94.075 71.2152 90.2465 70.1895 88.5176 67.1952C86.789 64.201 87.8151 60.3724 90.8092 58.6438C93.8032 56.9151 97.632 57.9408 99.3606 60.9351C101.089 63.9294 100.064 67.7579 97.0693 69.4865Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPicture);
export default __webpack_public_path__ + "static/media/no-picture.6d90ba3fbf16e062e2bfc531246a66f3.svg";
export { ForwardRef as ReactComponent };